/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import * as _ from 'underscore';
import ConnectSocialDialog from '@/shadcn/components/AddSocialModal/ConnectSocialDialog.tsx';

class CreateFeedOutputPanel extends React.Component {
    constructor(props) {
        super(props);

        let constants = window.DlvrConstants;

        this.state = {
            feed: {
                psID: constants.POST_SVC_FEED,
                rID: 0,
                creds: {
                    numItems: 10,
                    guid: ''
                },
                name: '',
                staticTitle: '',
                activeFlag: 1
            }
        };

        this.onCancel = this.onCancel.bind(this);
        this.createFeedOutput = this.createFeedOutput.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let constants = window.DlvrConstants,
            feed = state.feed;


        if (props.router.params) {
            if (props.router.params.routeId !== undefined) {
                feed.rID = parseInt(props.router.params.routeId);
                return {
                    feed
                };
            }
        } else if (props.routeId) {
            feed.rID = parseInt(props.routeId);
            return {
                feed
            };
        }

        // create was triggered by the + button on the list row
        if (props.activeRoute) {
            feed.rID = parseInt(props.activeRoute.id);
            return {
                feed
            };
        }

        return null;
    }

    /*
     * Back to the output feeds already connected, or to the network picker where
     * there are none.
     *
     * This used to read a `constants` that was never declared in its scope and
     * to test POST_SVC_BLUESKY — both carried over from the Bluesky panel this
     * was copied from — so it threw before it could navigate, and closed every
     * modal on the way. Going back is not closing.
     */
    onCancel() {
        let constants = window.DlvrConstants;

        if (!this.props.router.location.pathname.match("/config/social") &&
            !this.props.router.location.pathname.match("/content/post") &&
            _.findWhere(this.props.socials.counts, {type: constants.POST_SVC_FEED}) !== undefined) {
            this.props.switchView("chooseAcct", constants.POST_SVC_FEED);
        } else {
            this.props.switchView("chooseType");
        }

    }

    /*
     * One handler for every control, keyed by the state path the field carries.
     * Routed through requestChange rather than setState so the nested paths
     * (`feed.creds.numItems`) are written the same way every other editor panel
     * writes them.
     */
    onFieldChange(path, value) {
        FormUtilityMixin.requestChange.call(this, {
            currentTarget: {dataset: {field: path}},
            target: {value: value}
        });

    }

    createFeedOutput() {
        if (_.isFunction(this.props.setNewSocial)) {
            this.props.setNewSocial(this.state.feed);
        }
        this.props.createSocial(this.state.feed);

    }

    /*
     * The four controls the frame draws, over the same state paths the legacy
     * fieldsets wrote to — `feed.params.staticTitle` included, which is where
     * this has always sent the static title even though it also keeps an unused
     * `feed.staticTitle`. Read back from the path it writes, so the field shows
     * what will actually be sent.
     */
    fields() {
        let params = this.state.feed.params || {};

        return [
            {
                id: 'feed.name',
                label: 'Output Feed Name',
                placeholder: 'e.g. My Instagram Feed',
                required: true,
                value: this.state.feed.name || ''
            },
            {
                id: 'feed.creds.numItems',
                label: 'Max Items in Output Feed',
                kind: 'select',
                value: String(this.state.feed.creds.numItems),
                options: ['5', '10', '15', '20']
            },
            {
                id: 'feed.params.staticTitle',
                label: 'Static Title for Items',
                placeholder: 'e.g. Shop our latest arrivals',
                value: params.staticTitle || '',
                hint: 'Used as the title for every item posted to the feed.'
            },
            {
                id: 'feed.activeFlag',
                label: 'Output Feed Active',
                kind: 'switch',
                checked: parseInt(this.state.feed.activeFlag, 10) === 1
            }
        ];
    }

    render() {
        return (
            <ConnectSocialDialog
                screen="output-feed"
                network="rss"
                title="Output Feed settings"
                fields={this.fields()}
                primaryLabel="Connect"
                primaryDisabled={String(this.state.feed.name || '').trim() === ''}
                backLabel="Back"
                onFieldChange={(path, value) => {
                    /*
                     * The switch reports a boolean and the select a string; the
                     * backend wants activeFlag as 1/0 and numItems as a number,
                     * which is what the legacy Toggle and StyledSelect handed it.
                     */
                    if (path === 'feed.activeFlag') {
                        this.onFieldChange(path, (value) ? 1 : 0);
                        return;
                    }
                    if (path === 'feed.creds.numItems') {
                        this.onFieldChange(path, parseInt(value, 10));
                        return;
                    }

                    this.onFieldChange(path, value);
                }}
                onPrimary={this.createFeedOutput}
                onBack={this.onCancel}
                onClose={this.props.closeAllModals} />
        );
    }

};

CreateFeedOutputPanel.displayName = "CreateFeedOutputPanel";

CreateFeedOutputPanel.propTypes = {
    switchView: PropTypes.func,
    router: PropTypes.object
};

CreateFeedOutputPanel.defaultProps = {
    switchView: null,
    router: null
};

export default CreateFeedOutputPanel;
